module.exports = __webpack_public_path__ + "static/img/装饰3.40b68ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/penholder/imgs/装饰3.svg
// module id = L3xe
// module chunks = 2